export default __webpack_public_path__ + "i18n/translation-gu.4caf5a2a.json";